// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseDemoRoutesAreaRoutes = {
  route: '/demo-routes',
  Detail: {
    route: '/:id',
  },
}

export const DemoRoutesAreaRoutes = transformRoutes(BaseDemoRoutesAreaRoutes)
